export const GET_CONFIG = 'GET_CONFIG';
export const GET_CONFIG_SUCCESS = 'GET_CONFIG_SUCCESS';
export const GET_CONFIG_ERROR = 'GET_CONFIG_ERROR';
export const ADD_CONFIG = 'ADD_CONFIG';
export const EDIT_CONFIG = 'EDIT_CONFIG';
